<template>
  <CChartLine
    :datasets="defaultDatasets"
    :options="defaultOptions"
    :labels="['January','February','March','April','May','June','July','August','September','October','November','December']"
    :monthdatasets="monthDatasets"
    :monthoptions="monthOptions"
    :monthlabels="['Jan','Feb','Mar','Apr','May','June','July','Aug','Sep','Oct','Nov','Dec']"
  />

  
  <!-- :labels="['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']" -->

</template>
<script>
import { CChartLine } from '@coreui/coreui-vue-chartjs'
import { getColor, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { lightblue, blue } from 'color-name'

function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}


export default {
        name: 'NewRegisterChartYear',
  components: {
    CChartLine
  },
  computed: {
    defaultDatasets () {
      const brandSuccess = getColor('success') || '#4dbd74'
      const brandInfo = getColor('info') || '#20a8d8'
      const brandDanger = getColor('danger') || '#f86c6b'
      const brandWarning = getColor('warning') 
      const brandPrimary = getColor('primary')

      let elements = 12
      const VSB = []
      const VPM = []
      const VSM = []
      const VIT = []
      const TCM = []
      const SIM = []
      const MEL = []
      const CFY = []
      const OverAll=[]
      const FindMax=[]
      
      for (let i = 0; i <= elements; i++) {
        var Sum=0
        VSB.push(random(500, 700))
        VPM.push(random(200, 400))
        VSM.push(random(300, 600))
        VIT.push(random(300, 500))
        TCM.push(random(400, 600))
        SIM.push(random(300, 600))
        MEL.push(random(300, 600))
        CFY.push(random(300, 600))
        Sum = VSB[i]+VPM[i]+VSM[i]+VIT[i]+TCM[i]+SIM[i]+MEL[i]+CFY[i]
        OverAll.push(Sum)
      }

      FindMax.push(VSB)
      FindMax.push(VPM)
      FindMax.push(VSM)
      FindMax.push(VIT)
      FindMax.push(TCM)
      FindMax.push(SIM)
      FindMax.push(MEL)
      FindMax.push(CFY)


      const Max = Math.max.apply(Math,this.FindMax)

      return[
        {
          label: 'OverALL',
          backgroundColor: 'transparent',
          borderColor: '#009933',
          pointHoverBackgroundColor: '#009933',
          borderWidth: 2,
          data: OverAll,
        },
        {
          label: 'VSB',
          backgroundColor: 'transparent',
          borderColor: brandInfo,
          pointHoverBackgroundColor: brandInfo,
          borderWidth: 1,
          data: VSB,
          hidden: true
          
        },        {
          label: 'VPM',
          backgroundColor: 'transparent',
          borderColor: brandSuccess,
          pointHoverBackgroundColor: brandSuccess,
          borderWidth: 1,
          data: VPM,
          hidden: true
        },
        {
          label: 'VSM(VMM)',
          backgroundColor: 'transparent',
          borderColor: brandWarning,
          pointHoverBackgroundColor: brandWarning,
          borderWidth: 1,
          data: VSM,
          hidden: true
        },
        {
          label: 'VIT',
          backgroundColor: 'transparent',
          borderColor: brandDanger,
          pointHoverBackgroundColor: brandDanger,
          borderWidth: 1,
          data: VIT,
          hidden: true
        },
        {
          label: 'TCM',
          backgroundColor: 'transparent',
          borderColor: brandPrimary,
          pointHoverBackgroundColor: brandPrimary,
          borderWidth: 1,
          data: TCM,
          hidden: true
        },
        {
          label: 'SIM',
          backgroundColor: 'transparent',
          borderColor: '#7D3C98',
          pointHoverBackgroundColor: '#7D3C98',
          borderWidth: 1,
          data: SIM,
          hidden: true
        },
        {
          label: 'MEL',
          backgroundColor: 'transparent',
          borderColor: '#E67E22',
          pointHoverBackgroundColor: '#E67E22',
          borderWidth: 1,
          data: MEL,
          hidden: true
        },
        {
          label: 'CFY',
          backgroundColor: 'transparent',
          borderColor: '#0B5345',
          pointHoverBackgroundColor: '#0B5345',
          borderWidth: 1,
          data: CFY,
          hidden: true
        }
      ]
    },
    
    defaultOptions () {
      return {
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 10,
              stepSize: Math.ceil(this.a / 5),
              max: this.a
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    }
  }
}
  
</script>



// WEBPACK FOOTER //
// src/components/Chart/NewRegisterChartYear.vue